import { render } from "./AccountMenu.vue?vue&type=template&id=e1b5a15c&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountMenu.vue?vue&type=script&setup=true&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=e1b5a15c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b5a15c"],['__file',"src/components/app/nav/AccountMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1b5a15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1b5a15c', __exports__)) {
    api.reload('e1b5a15c', __exports__)
  }
  
  module.hot.accept("./AccountMenu.vue?vue&type=template&id=e1b5a15c&scoped=true", () => {
    api.rerender('e1b5a15c', render)
  })

}


export default __exports__